import React from 'react';
import { useParams } from 'react-router-dom';
import { PostPreview } from './Blog.components';
import { blogGroupData, blogData } from './Blog.data';

const BlogGroupLanding = () => {
  const { blogGroup } = useParams();
  const currentBlogGroup = blogGroupData.find(
    (item) => item.blogGroupUrl === blogGroup
  );

  console.log('blogGroup param:', blogGroup);
  console.log('currentBlogGroup:', currentBlogGroup);

  const posts = blogData.filter((item) => item.blogGroupUrl === blogGroup);

  return (
    <div className='content-container blog-landing-page'>
      <div className='section-light'>
        <div className='section-container grid'>
          <h1 className='large text-primary'>{currentBlogGroup.title}</h1>
          <p className='lead'>{currentBlogGroup.body}</p>
          <div className='post-container'>
            {posts.map((post, index) => (
              <PostPreview key={index} post={post} blogGroup={false} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogGroupLanding;
